import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import React from "react";

import BriaVideo from "../../common/BriaVideo/BriaVideo.tsx";
import styles from "./VideoPopup.module.scss";

interface VideoPopupProps {
	isOpen: boolean;
	videoSrc: string;
	onClose: () => void;
}

const VideoPopup: React.FC<VideoPopupProps> = ({ isOpen, videoSrc, onClose }) => {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			aria-labelledby="video-popup-title"
			maxWidth="md"
			classes={{
				paper: styles.videoPopupPaper,
			}}
		>
			<DialogContent className={styles.videoPopupContent}>
				<BriaVideo videoSrc={videoSrc} autoPlay={true} />
			</DialogContent>
		</Dialog>
	);
};

export default VideoPopup;
